
import { debounce } from "debounce";
import { Logger } from '../util/log.js';

(function($){

    var $controller  = {

        debug: true,

        logger: null,

        delay: 100,
        throttle: 400,

        selector: '.wine-fs',
        el: null,

        siblingSelector: '.wine-quotes',
        sibling: null,

        init: function() {
            this.logger = new Logger({debug: this.debug});
            this.el = $(this.selector);
            this.sibling = $(this.siblingSelector);
            if(this.el.length > 0) {
                setTimeout(function() {
                    $controller.listen();
                }, this.delay);
            }
        },
        
        listen: function() {

            this.resize();

            $(window).resize(debounce(this.resize, this.throttle));

        },

        resize: function() {

            var $width = $controller.getContainerWidth();
            
            var $breakpoints = [
                { breakpoint: 1680, callback: (function () { $controller.xl() }) },
                { breakpoint: 1025, callback: (function () { $controller.large() }) },
                { breakpoint: 570, callback: (function() { $controller.tablet(); })},
                { breakpoint: 0, callback: (function() { $controller.xs(); })}
            ];

            $.each($breakpoints, function() {
                if(this.breakpoint <= $width) {
                    this.callback();
                    return false;
                }
            });

        },

        getContainerWidth() {
            var $width = $(window).width();
            $controller.log('container width', $width);
            return $width;
        },

        getContainerHeight() {
            $controller.getContainerWidth();
            var $height = $(window).outerHeight(true);
            $controller.log('container height', $height);
            return $height;
        },

        getOtherHeight: function($includeSibling) {

            var $height = 0;

            var $check = [
                $('#wpadminbar'),
                $('#masthead'),
            ];

            this.log('include sibling', $includeSibling);

            if($includeSibling) {
                $check.push(this.sibling);
            }

            $.each($check, function($idx, $el) {
                $height += $el && $el.length > 0 ? $el.outerHeight(true) : 0;
            });

            return $height;

        },

        // shared height with sibling
        xl: function() {

            var $height = this.getContainerHeight();
            $height -= this.getOtherHeight(true);
            this.el.css('height', $height+'px');

            this.log('breakpoint', 'xl');

        },

        // full height
        large: function() {
            
            var $height = this.getContainerHeight();
            $height -= this.getOtherHeight(false);
            this.el.css('height', $height+'px');

            this.log('breakpoint', 'large');

        },

        tablet: function() {
            
            this
                .el
                    .css('height', 'auto');

            
            $('img', this.el).css('height', '100%');

        },

        xs: function() {

            var $height = this.getMinHeight();

            this
                .el
                    .css('height', 'auto');

            $('img', this.el).css('height', $height+'px');

        },

        getMinHeight: function() {
            var $height = 0;
            this.el.each(function() {
                var $img = $(this).find('img');
                if($img && $img.length > 0) {
                    var $i = new Image();
                    $i.src = $img.attr('src');
                    if($i.height > $height) {
                        $height = $i.height;
                    }
                }
            });
            return $height;
        },

        log: function() {
            $controller.logger.store.apply($controller.logger, arguments);
        }

    };

    $controller.init();

})(jQuery, debounce, Logger);


// WEBPACK FOOTER //
// ./tbo/js/widget/wine.js